<template>
	<div>
        <div class="bright container-fluid py-2">
            <router-view @childrenRoute="hideNonChildren" />
            <div class="row" v-if="!isChildRoute">

            </div>
        </div>
    </div>
</template>

<script>

export default
{
	//extends: Bright,
	components: {
		//ReportParamSelect,
	},

	data() {
		return {
            isChildRoute: false,
        }
    },
    watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
	},
    mounted() {
        this.$emit('childrenRoute');
        this.hideNonChildren();
    },
    methods: {
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/hsse';
        },
    },
}
</script>
